import {
  FavoriteOptionsData,
  GameList,
  GamesFavoritesClient,
} from "@nestcoinco/hyper-api-gateway-api-client";

import apiConfig from "../config/api-config";
import { axiosInstance } from "../config/axios-instance";

const gamesFavoritesClient = new GamesFavoritesClient(
  apiConfig,
  undefined,
  axiosInstance
);

const handleGetMyFavoriteGames = async ({
  limit,
  page,
}: {
  limit?: number;
  page?: number;
}): Promise<GameList> => {
  return (await gamesFavoritesClient.getUserFavoriteGames(limit, page)).data;
};

const updateGameFavoriteStatus = async (
  gameId: string,
  isFavorite: boolean
): Promise<FavoriteOptionsData> => {
  return (await gamesFavoritesClient.upsertFavoriteGame(gameId, { isFavorite }))
    .data;
};

export { handleGetMyFavoriteGames, updateGameFavoriteStatus };
